import sanityClient from "@sanity/client";

export default sanityClient({
    projectId : "c342p7z3",
    dataset : "production"
})